import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export interface FilterHeaderProps {
  fieldName: string;
  filterMode: 'include' | 'exclude';
  onFilterModeChange: (mode: 'include' | 'exclude') => void;
}

export const FilterHeader: React.FC<FilterHeaderProps> = ({
  fieldName,
  filterMode,
  onFilterModeChange,
}) => {
  return (
    <div className="flex items-center justify-between gap-3 pb-2 border-b border-border px-3">
      <div className="flex items-center gap-2 flex-1">
        <span className="font-semibold text-sm text-foreground uppercase">
          {fieldName}
        </span>
      </div>
      <div className="flex-shrink-0">
        <Select value={filterMode} onValueChange={onFilterModeChange}>
          <SelectTrigger className="w-auto">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="include">Include</SelectItem>
            <SelectItem value="exclude">Exclude</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
